import {
  UPDATE_CONTROLLER_FIELD,
  UPDATE_MANAGEMENT_FIELD,
  SUBMIT_MANAGEMENT_INFO_COMPLETE,
  SUBMIT_MANAGEMENT_INFO
} from '../actions/significantController';

import {
  GET_APPLICATION_COMPLETE
} from '../actions/onboarding';

const defaultState = {
  controller: { address: {}, type: 'CONTROLLER' },
  verifierFirstname: '',
  verifierLastname: '',
  verifierTitle: '',
  isVerified: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_CONTROLLER_FIELD:
      const { field, value, errors } = action;
      const splitFields = field.split('.');
      const root = { ...state };
      splitFields.reduce((acc, f, idx) => {
        if (idx === splitFields.length - 1) {
          acc[f] = value;
          return acc;
        }
        return acc[f];
      }, root);
      root.controller.errors = errors;
      return { ...state, ...root};
    case UPDATE_MANAGEMENT_FIELD: {
      const { field, value } = action;
      return { ...state, [field]: value };
    }
    case 'SELECT_CONTROLLER':
      const controller = { ...state.controller };
      return { ...state, controller };
    case SUBMIT_MANAGEMENT_INFO: {
      const { hasError, controller } = action;
      if (hasError) {
        return { ...state, controller };
      }
      return state;
    }
    case SUBMIT_MANAGEMENT_INFO_COMPLETE: {
      const { significantController: { controller} } = action.payload;
      return { ...state, controller };
    }
    case GET_APPLICATION_COMPLETE:
      const { significantController } = action.payload;
      return { ...significantController };
    default:
      return state;
  }
};

